import React, { memo } from 'react';

import { Container } from './styles';

const Separator = (): JSX.Element => {
  return <Container />;
};

export default memo(Separator);
